import { TemplateRef } from "@angular/core";

export class BoxTab {
    desc? : string;
    template? : TemplateRef<any>; // in angular


    constructor(public code : string, public title : string){}
}
